import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  userIcon: {
    color: theme.palette.text.primary,
    marginLeft: theme.spacing(1),
    width: theme.spacing(3.125),
    height: theme.spacing(3.125),
    [theme.breakpoints.down("md")]: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      marginLeft: theme.spacing(0.5),
    },
  },
  userPresence: {
    color: theme.palette.present.greyBackground,
    display: "flex",
    flexDirection: "column",
    transition: "all 0.5s",
    justifyContent: "center",
    cursor: "pointer",
    height: theme.spacing(6.875),
    borderRight: `1px solid ${theme.palette.border.default}`,
    [theme.breakpoints.down("md")]: {
      height: theme.spacing(6),
    },
  },
  liveUsersCount: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      paddingRight: theme.spacing(0.5),
    },
  },
  streaming: {
    color: theme.palette.error.main,
    display: "flex",
    alignItems: "center",
  },
}));
